import React, { useState, useEffect } from "react";
import AboutUsCSS from "./AboutUs_dev.module.css";
import NewHeader from "../components/NewHeader_dev";
import AboutUs_dev from "../components/AboutUs_dev";
import Footer from "../components/Footer";

import Loader from "../components/Loader";

function AboutUs() {
    return (
      <div className={AboutUsCSS.content}>
        <NewHeader />
        <div>
            <AboutUs_dev />
            <br />
            <br />          
            <Footer />            
          </div>
      </div>
    );
  }
  export default AboutUs;
